import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { getRegionLanguages } from './utils/useRegions';

const languageDetector = new LanguageDetector();
const regionDetector = {
  name: 'regionDetector',

  lookup() {
    const region = window.location.pathname.split('/')[1];
    const regionLang = getRegionLanguages(region)?.[0];
    return regionLang || null;
  },

  cacheUserLanguage(lng, options) {
    console.log(lng, options);
  },
};
languageDetector.addDetector(regionDetector);

i18n
  .use(Backend)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    ns: ['translation', 'countries'],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['a'],
    },
    detection: {
      order: ['regionDetector', 'path'],
      lookupFromPathIndex: 0,
    },
    backend: {
      allowMultiLoading: true,
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    cleanCode: true,
  });

export default i18n;
